(function (scope) {
  'use strict';
  const PROJECT = 'z3cus6ybf8';
  const HOSTS = new Set(['www.dotsontuning.com', 'dotsontuning.com']);
  const REFERRERS = new Set(['google.com', 'www.google.com', 'bing.com', 'www.bing.com', 'chatgpt.com', 'www.chatgpt.com', 'perplexity.ai', 'www.perplexity.ai', 'claude.ai', 'gemini.google.com', 'copilot.microsoft.com', 'facebook.com', 'www.facebook.com', 'instagram.com', 'www.instagram.com', 'youtube.com', 'www.youtube.com', 'tiktok.com', 'www.tiktok.com', 'reddit.com', 'www.reddit.com']);
  function publicUrl(value) {
    try {
      const url = new URL(value);
      if (url.protocol !== 'https:' || !HOSTS.has(url.hostname) || url.hash || url.username || url.password || url.port) return false;
      if (!(/^\/$/.test(url.pathname) || /^\/(?:products|collections)\/[a-z0-9-]+\/?$/.test(url.pathname) || /^\/pages\/(?:tuning|mach-v-motorsports|efi-performance|ethanol-mix-calculator)\/?$/.test(url.pathname))) return false;
      for (const [key, val] of url.searchParams) if (key !== 'variant' || !/^\d{1,20}$/.test(val)) return false;
      return url.searchParams.getAll('variant').length <= 1;
    } catch (_) { return false; }
  }
  function safeContext(env) {
    if (!publicUrl(env.location.href) || env.Shopify?.theme?.role !== 'main' || env.Shopify?.designMode) return false;
    if (env.top && env.self && env.top !== env.self) return false;
    if (env.navigator?.globalPrivacyControl === true || [env.navigator?.doNotTrack, env.navigator?.msDoNotTrack, env.doNotTrack].some(value => value === '1' || value === 1 || value === 'yes')) return false;
    try {
      // Descendant unmask rules override a masked ancestor. Never start over one.
      if (env.document.querySelector('[data-clarity-unmask]')) return false;
      if (env.document.referrer) {
        const ref = new URL(env.document.referrer);
        if (ref.search || ref.hash || ref.protocol !== 'https:' || ref.username || ref.password || ref.port) return false;
        if (HOSTS.has(ref.hostname)) { if (!publicUrl(ref.href)) return false; }
        // Clarity collects document.referrer. Unknown hosts and nonpublic paths
        // may contain identifiers even without a query string, so fail closed.
        else if (!REFERRERS.has(ref.hostname) || ref.pathname !== '/') return false;
      }
      return true;
    } catch (_) { return false; }
  }
  function install(env) {
    if (env.__dotsonClarity || !safeContext(env) || env.clarity || typeof env.location.reload !== 'function' || typeof env.MutationObserver !== 'function') return null;
    let requested = false, stopped = false, script = null, maskedBody = null;
    const allowed = () => {
      try { return safeContext(env) && env.Shopify.customerPrivacy.analyticsProcessingAllowed() === true && env.Shopify.customerPrivacy.currentVisitorConsent().analytics === 'yes'; }
      catch (_) { return false; }
    };
    function stop(unload = true) {
      if (!requested) return;
      const firstStop = !stopped;
      stopped = true;
      // Removal alone cannot cancel code already fetched. Clear an unprocessed
      // grant, and repeat deny/stop if a delayed tag still reaches its load event.
      if (script && typeof script.remove === 'function') script.remove();
      if (Array.isArray(env.clarity?.q)) env.clarity.q.length = 0;
      try { env.clarity('consentv2', {analytics_Storage:'denied', ad_Storage:'denied'}); } catch (_) {}
      try { env.clarity('stop'); } catch (_) {}
      // Consent denial can schedule Clarity's internal cookieless restart.
      // Unload vendor code; the next document must pass fresh consent/URL gates.
      if (firstStop && unload) env.location.reload();
    }
    function check() {
      if (stopped) return;
      if (!allowed()) { stop(); return; }
      if (requested && (env.document.body !== maskedBody || maskedBody.getAttribute('data-clarity-mask') !== 'true')) { stop(); return; }
      if (requested || stopped || !env.document.body) return;
      requested = true;
      // Strict project masking plus a local rule that also covers newly inserted content.
      maskedBody = env.document.body;
      maskedBody.setAttribute('data-clarity-mask', 'true');
      env.clarity = function () { (env.clarity.q = env.clarity.q || []).push(Array.from(arguments)); };
      env.clarity('consentv2', {analytics_Storage:'granted', ad_Storage:'denied'});
      script = env.document.createElement('script');
      script.async = true;
      script.src = 'https://www.clarity.ms/tag/' + PROJECT;
      script.referrerPolicy = 'no-referrer';
      script.onload = () => { if (stopped || !allowed()) stop(); };
      // A blocked tag never executed. Leave this page alone and do not create a
      // reload loop for visitors whose browser blocks the vendor download.
      script.onerror = () => stop(false);
      env.document.head.appendChild(script);
    }
    // pushState/replaceState do not emit popstate. Check synchronously after a
    // same-document URL change, before a later vendor route callback can run.
    const historyOriginals = {};
    try {
      for (const name of ['pushState', 'replaceState']) {
        if (typeof env.history[name] !== 'function') return null;
        historyOriginals[name] = env.history[name];
      }
      for (const name of ['pushState', 'replaceState']) {
        const original = historyOriginals[name];
        const wrapped = function () { const result = original.apply(this, arguments); check(); return result; };
        env.history[name] = wrapped;
        if (env.history[name] !== wrapped) throw new Error('History observation unavailable');
      }
    } catch (_) {
      for (const name of Object.keys(historyOriginals)) { try { env.history[name] = historyOriginals[name]; } catch (_) {} }
      return null;
    }
    env.__dotsonClarity = {check};
    env.document.addEventListener('visitorConsentCollected', check);
    env.document.addEventListener('visibilitychange', check);
    env.addEventListener('popstate', check);
    env.addEventListener('hashchange', check);
    env.addEventListener('pageshow', check);
    const observer = new env.MutationObserver(check);
    observer.observe(env.document.documentElement, {childList:true, subtree:true, attributes:true, attributeFilter:['data-clarity-mask', 'data-clarity-unmask']});
    if (env.document.readyState === 'loading') env.document.addEventListener('DOMContentLoaded', check, {once:true});
    check();
    if (!env.Shopify?.customerPrivacy && typeof env.Shopify?.loadFeatures === 'function') {
      env.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], function (error) { if (!error) check(); });
    }
    return env.__dotsonClarity;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {install,publicUrl,safeContext};
  else install(scope);
})(typeof window !== 'undefined' ? window : globalThis);
